import Actions                  from 'Redux/Actions';
import { ofType }               from 'redux-observable';
import { from }                 from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';
import { OrganizerRepository }  from 'Domain/Repositories';
import { message }              from 'antd';

export const deleteOrganizerEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.deleteOrganizerRequest.type),
    mergeMap(action => from(OrganizerRepository.remove(action.payload.id))
      .pipe(
        mergeMap(() => {
          message.success('Organisator wurde erfolgreich gelöscht.');
          return from([
            Actions.deleteOrganizerSuccess({ id: action.payload.id }),
          ]);
        }),
        catchError(error => {
          return from([
            Actions.deleteOrganizerFailure(error),
          ]);
        })
      )
    ),
  );
};
